<template>
<v-list-tile >
  <v-list-tile-content>
    <v-list-tile-title>
      {{value.first_name}} {{value.last_name}}
      <small>({{value.year_of_birth}})</small>
    </v-list-tile-title>
    <v-list-tile-sub-title>
      {{value.email}}
    </v-list-tile-sub-title>
  </v-list-tile-content>
  <slot name='action' >
  </slot>
</v-list-tile>
</template>
<script>
export default {
  name: 'PhysitrackClientListItem',
  props: {
    value: { type: Object, required: true }
  }
}
</script>



// WEBPACK FOOTER //
// PhysitrackClientListItem.vue?6dce2146